import { useRouter } from 'next/compat/router';
import { oneLine } from 'common-tags';

import { Button, Container } from '@/atoms';
import { ButtonSize, ButtonVariant } from '@/atoms/button/types';

/**
 * ComponentRevisadasOtraDuda
 */
import { sectionBgProps, textStyleClass } from '@/utils';

export const ComponentRevisadasOtraDuda = ({
  Titulo,
  Descripcion,
  TituloEstilo,
  DescripcionEstilo,
  TextoBoton,
  LinkBoton,
  FondoSeccion,
}: any) => {
  const router = useRouter();
  const tituloCls = textStyleClass(TituloEstilo);
  const descripcionCls = textStyleClass(DescripcionEstilo);
  return (
    <Container wrapper {...sectionBgProps(FondoSeccion)}>
      <div className="bg-neutrals-50 flex flex-col gap-6 px-8 py-12">
        <div className="flex flex-col gap-2">
          <h4 className={tituloCls}>{Titulo}</h4>
          <p className={oneLine`${descripcionCls ?? 'text-body-m'}`}>
            {Descripcion}
          </p>
        </div>

        <div className="w-32">
          <Button
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
            onClick={() => router?.push(LinkBoton)}
          >
            {TextoBoton}
          </Button>
        </div>
      </div>
    </Container>
  );
};

ComponentRevisadasOtraDuda.displayName = 'ComponentRevisadasOtraDuda';
